<template>
    <div>
      <h2 class="text-2xl font-bold mb-4">📦 Reporte de Inventario</h2>
  
      <div v-if="productos.length">
        <table class="w-full table-auto text-sm border">
          <thead class="bg-gray-100">
            <tr>
              <th class="p-2 border">Producto</th>
              <th class="p-2 border">Stock</th>
              <th class="p-2 border">Precio Venta</th>
              <th class="p-2 border">Costo Unitario</th>
              <th class="p-2 border">Valor Inventario</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="p in productos" :key="p.id">
              <td class="p-2 border">{{ p.nombre }}</td>
              <td class="p-2 border">{{ p.stock }}</td>
              <td class="p-2 border">${{ p.precio?.toFixed(2) ?? '0.00' }}</td>
              <td class="p-2 border">${{ p.costo?.toFixed(2) ?? '0.00' }}</td>
              <td class="p-2 border font-bold">
                ${{ (p.stock * (p.costo ?? 0)).toFixed(2) }}
              </td>
            </tr>
          </tbody>
        </table>
  
        <div class="mt-6 text-sm space-y-1">
          <div><strong>🔢 Total de productos:</strong> {{ productos.length }}</div>
          <div><strong>💰 Valor total de inventario:</strong> ${{ valorInventario.toFixed(2) }}</div>
        </div>
      </div>
  
      <div v-else class="text-gray-500 mt-6">No hay productos en inventario.</div>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue'
  import { db } from '@/firebase'
  import { collection, getDocs } from 'firebase/firestore'
  
  const productos = ref([])
  const valorInventario = ref(0)
  
  const cargarProductos = async () => {
    const snap = await getDocs(collection(db, 'productos'))
    productos.value = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))
    valorInventario.value = productos.value.reduce(
      (total, p) => total + ((p.costo ?? 0) * (p.stock ?? 0)),
      0
    )
  }
  
  onMounted(cargarProductos)
  </script>
  